import { Box, Stack } from '@mui/material';
import React from 'react';
import FileAttachment from '../../atoms/dashboard-details-v2/FileAttachment';
import DataFieldBox from '../../atoms/dashboard-details-v2/DataFieldBox';
import { CompanyFile } from '../../../types/files';

type DocumentsSectionProps = {
    files: CompanyFile[];
    links: string[];
    allFiles: CompanyFile[];
    onFileClick: (file: CompanyFile) => void;
    onDeleteLink?: (link: string) => void;
};

const DocumentsSection: React.FC<DocumentsSectionProps> = ({ files, links, allFiles, onFileClick, onDeleteLink }) => {
    const count = files.length + links.length;
    if (count === 0) return null;
    return (
        <DataFieldBox label="Documents" count={count}>
            <Stack direction="column" gap={1}>
                {files.map((file, i) => (
                    <Box key={`file-${i}`} onClick={() => onFileClick(file)}>
                        <FileAttachment resName={file.name} file={file} />
                    </Box>
                ))}
                {links.map((link, i) => (
                    <Box key={`link-${i}`}>
                        <FileAttachment
                            resName={link}
                            file={allFiles?.length === 1 && links?.length === 1 ? allFiles[0] : undefined}
                            onDelete={onDeleteLink ? () => onDeleteLink(link) : undefined}
                        />
                    </Box>
                ))}
            </Stack>
        </DataFieldBox>
    );
};

export default DocumentsSection;
